import Vue from "vue";
import Vuex from "vuex";
import {
  pageSettingsResource,
  executiveProgramResource,
} from "./api/resources";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageSettings: null,
    executiveProgramUrl: null,
    externalEventId: null,
  },
  mutations: {
    setPageSettings(state, payload) {
      state.pageSettings = payload;
    },
    setExecutiveProgramUrl(state, payload) {
      state.executiveProgramUrl = payload;
    },
    setExternalEventId(state, payload) {
      state.externalEventId = payload;
    },
  },
  actions: {
    async getPageSettings({ commit }) {
      const settings = await pageSettingsResource.get(
        window.pageId || "cm4ifr4bo00br6sqd1h38xg0t" //"cm1z389q5002bbd5hxxhyu4ia",
      );
      commit("setPageSettings", settings.data);
    },
    async getExecutiveProgramData({ commit }) {
      const externalEventId = await executiveProgramResource.get("");
      commit("setExternalEventId", externalEventId.data.eventId);
      commit("setExecutiveProgramUrl", externalEventId.data.url);
    },
  },
  getters: {
    pageSettings: (state) => state.pageSettings,
    embeddedVideoUrl: () => (url) => {
      const parser = document.createElement("a");
      parser.href = url;
      const variables = parser.search.substring(1).split("&");
      for (let variable of variables) {
        const pair = variable.split("=");
        if (pair[0] === "v") {
          return "https://youtube.com/embed/" + decodeURIComponent(pair[1]);
        }
      }
      return url;
    },
    executiveProgramUrl: (state) => state.executiveProgramUrl,
    externalEventId: (state) => state.externalEventId,
  },
});
